import React from "react";
import { Link } from "react-router-dom";
import { Breadcrumb } from "react-bootstrap";
import { DefaultRoutes, PathInfo, GenericEntryEntity, DriveEntryType, buildNavigationLink } from "src/common";
import _ from "lodash";

type AllProps = {
  entry: GenericEntryEntity;
  path_info?: PathInfo[];
}

// Description: Breadcrumbs component for Drive Starred entries
// NOTE: This component is used to display the path of the starred entry in a breadcrumb format
// It uses the `useGetPathList` hook to build the breadcrumbs based on the entry
// and the full path list provided. It also handles the tooltip for the breadcrumbs.
function BreadcrumbsComponent(props: AllProps) {
  const { entry, path_info } = props; // 

  // Description: Build File type last node url to MyPreVeil link
  function getEntityURLbyType(node: PathInfo) {
    return (entry.type === DriveEntryType.FILE && entry.id === node.id && !!entry.parent_id) ?
      buildNavigationLink(entry.collection_id, entry.parent_id, entry.type, entry.id) : (node.url || DefaultRoutes.drive_root);
  }

  return <>
    <Breadcrumb className="drive-breadcrumbs">
      {
        !!path_info &&
        _.map(path_info, (node: PathInfo, index: number) => {
          const is_last = Number(length - 1) === index;
          // NOTE: Check if the node should be rendered. Do not render if the path is a true root, only its link or if its the defaultCollection node
          return !node.is_true_root ?
            <Breadcrumb.Item
              key={`path_${index}`}
              as="span"
              onClick={(e) => { e.stopPropagation(); }}
              className={is_last ? "last" : (index === 0) ? "bc-title" : ""}
              linkAs={Link}
              linkProps={{ to: (!!entry.is_deleted && is_last ? "" : getEntityURLbyType(node)) }}>
              {node.path}</Breadcrumb.Item> : null;
        })
      }
    </Breadcrumb>
  </>;
}

export default React.memo(BreadcrumbsComponent);
